import React, { createElement, ReactElement } from 'react';

import cs from 'classnames';
import style from './style.module.scss';

export enum TypographyVariants {
    h1 = 'H1',
    h2 = 'H2',
    h3 = 'H3',
    pLargeX = 'p_large_x',
    pLargeXL = 'p_large_xl',
    body = 'body'
}

type TypographyProps<T extends keyof JSX.IntrinsicElements> = {
    component?: keyof JSX.IntrinsicElements
    children: string | ReactElement
    className?: string
    variant: TypographyVariants
    highlight?: boolean
} & JSX.IntrinsicElements[T];

const classNamesMap = {
  [TypographyVariants.h1]: {
    className: style.titleH1,
    tag: 'h1',
  },
  [TypographyVariants.h2]: {
    className: style.titleH2,
    tag: 'h2',
  },
  [TypographyVariants.h3]: { className: style.titleH3, tag: 'h3' },
  [TypographyVariants.pLargeX]: { className: style.textPLargeX, tag: 'p' },
  [TypographyVariants.pLargeXL]: { className: style.textPLargeXL, tag: 'p' },
  [TypographyVariants.body]: { className: style.textStandard, tag: 'p' },
};

export const Typography = <T extends keyof JSX.IntrinsicElements = 'p'>({
  component, children, variant, className, highlight, ...props
}: TypographyProps<T>): ReactElement => createElement(component ?? classNamesMap[variant].tag, { className: cs(classNamesMap[variant].className, { [style.highlight]: highlight }, className), ...props }, children);

Typography.defaultProps = {
  component: undefined,
  className: undefined,
  highlight: false,
};
